/**
 * 填写订单
 */
const goodsOrderLangCN = {
    fillInTheOrder:"填写订单",
    address:"地址",
    ClickSetAddress: "点击设置地址",
    goodsInformation: "商品信息",
    GoodsTogether:"商品合计",
    PromotionOptimizationAmount:"促销优化金额",
    freight:"运费",
    ChoosePaymentMethod:"选择支付方式",
    WeChatPay:"微信支付",
    Alipay:"支付宝支付",
    SubmitOrders:"提交订单",
}

const goodsOrderLangEN = {
    fillInTheOrder:"Ordering",
    address:"Address",
    ClickSetAddress: "Click set address",
    goodsInformation: "Commodity information",
    GoodsTogether:"Total",
    PromotionOptimizationAmount:"Promotion amount",
    freight:"Shipping",
    ChoosePaymentMethod:"Choose Payment Method",
    WeChatPay:"Wechat Pay",
    Alipay:"Ali Pay",
    SubmitOrders:"Place your order",
}

const langPackage = {
    cn:goodsOrderLangCN,
    en:goodsOrderLangEN
}


export {langPackage}
